import {
    ChangeConfigActionType,
    ChangeConfigSuccessActionType,
    ConfigActionTypes,
    InitConfigActionType,
    ChangeConfigFailureActionType,
} from "./types";
import { ActionCreator } from "./../types/store-types";

export const changeConfigs: ActionCreator<ChangeConfigActionType> = payload => ({
    type: ConfigActionTypes.CHANGE_CONFIGS_REQUEST,
    payload,
});

export const changeConfigsSuccess: ActionCreator<ChangeConfigSuccessActionType> = payload => ({
    type: ConfigActionTypes.CHANGE_CONFIGS_SUCCESS,
    payload,
});

export const initConfigs: ActionCreator<InitConfigActionType> = payload => ({
    type: ConfigActionTypes.INIT_CONFIGS,
    payload,
});

export const failureConfigs: ActionCreator<ChangeConfigFailureActionType> = payload => ({
    type: ConfigActionTypes.CHANGE_CONFIGS_FAILURE,
    payload,
});
